import * as React from 'react';

const BookLocal = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={40} height={40} fill="none" viewBox="0 0 40 40" {...props}>
        <rect width={40} height={40} fill="#3E71A9" rx={4} />
        <path
            fill="#fff"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.932}
            d="M30.235 18c0 8.985-7.883 14.024-9.813 15.126a.85.85 0 0 1-.845 0C17.647 32.025 9.765 26.985 9.765 18a10.235 10.235 0 0 1 20.47 0"
        />
        <path
            stroke="#3E71A9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M26.446 18.746 20 13.374l-6.446 5.372M18.506 19.352h2.988v4.3h-2.988z"
        />
        <path
            stroke="#3E71A9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M15.415 17.503v4.906c0 .687.556 1.243 1.242 1.243h6.686c.686 0 1.242-.556 1.242-1.243v-4.906"
        />
    </svg>
);
export default BookLocal;
